import FeatureSnippetLimitedUse from './FeatureSnippetLimitedUse';

export default FeatureSnippetLimitedUse;
export { FeatureSnippetLimitedUse };
